import styled from '@emotion/styled';
import React from 'react';
import { ListContainer } from '../tourneys-list/styles';

const TourneyCardSkeleton = styled.div`
  border-radius: 8px;
  height: 128px;
`;

const PaginationContentSkeleton = styled.div`
  border-radius: 8px;
  width: 216px;
  height: 24px;
`;

type TourneysListSkeletonProps = {
  resultsOnPage?: number;
};

const TourneysListSkeleton = ({ resultsOnPage = 9 }: TourneysListSkeletonProps) => {
  const items = new Array(resultsOnPage).fill('');

  return (
    <ListContainer className="w-full px-6">
      <div className="grid grid-cols-12 gap-3">
        {items.map((item, index) => (
          <div key={index} className="col-span-4">
            <TourneyCardSkeleton className="skeleton-block" />
          </div>
        ))}
      </div>
    </ListContainer>
  );
};

const PaginationSkeleton = () => {
  return (
    <div className="my-8 flex justify-end px-6">
      <PaginationContentSkeleton className="skeleton-block" />
    </div>
  );
};

type TourneysBodySkeletonProps = TourneysListSkeletonProps;

export const TourneysBodySkeleton = ({ resultsOnPage }: TourneysBodySkeletonProps) => {
  return (
    <>
      <TourneysListSkeleton resultsOnPage={resultsOnPage} />
      <PaginationSkeleton />
    </>
  );
};
